import Legal from './LegalViewer';
export default Legal;
